export enum UserPlatform {
    mac = 'mac',
    windows = 'windows',
    linux = 'linux',
    unknown = 'unknown',
}
